import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default {
	init() {

		document.body.classList.add("body--loaded");

		/* Paginacja */

		const articles = document.querySelectorAll(".articles__item--post");
		const wordpressPagination = document.querySelector(".page-numbers");

		const rebuildPagination = (element) => {

			element.classList.remove("page-numbers");
			element.classList.add("pagination");

			let listElements = Array.prototype.slice.call(element.children);

			listElements.forEach((item) => {
				item.classList.add("pagination__item");
			});
		};

		if (document.body.classList.contains("blog") && articles.length === 9) {
			rebuildPagination(wordpressPagination);
		}

		/* Dostosowanie wysokości na iOS */

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		window.addEventListener("resize", () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		});

		/* Menu pełnoekranowe */

		const menu = document.querySelector(".menu--top");
		const menuBtn = document.querySelector(".menu__btn");

		menuBtn.addEventListener("click", (e) => {
			e.currentTarget.classList.toggle("menu__btn--active");
			menu.classList.toggle("menu--is-open");

			if (menu.classList.contains("menu--is-open")) {
				document.querySelector(".investments").classList.add("investments--disabled");
			} else {
				document.querySelector(".investments").classList.remove("investments--disabled");
			}
		});

		/* Nadawanie klasy elementom nawigacji */

		const setClass = () => {

			const pathname = window.location.pathname;
			const menuItems = document.querySelectorAll(".menu--top .menu__link");
			const letter = document.querySelector(".letter");
			const offerRegEx = /\b(oferta)\b/g;
			const blogRegEx = /\b(blog)\b/g;

			if (pathname.match(offerRegEx)) {
				menuItems[1].classList.add("menu__link--active");
				if (window.innerWidth <= 1024) {
					letter.classList.add("letter--color");
				}
			} else if (pathname.match(blogRegEx)) {
				menuItems[4].classList.add("menu__link--active");
				if (window.innerWidth <= 1024) {
					letter.classList.add("letter--color");
				}
			}
		}

		setClass();

		/* Scroll */

		window.onscroll = () => {
			if (window.scrollY >= 1000) {
				document.querySelector(".scroll-top").classList.add("scroll-top--visible");
			} else {
				document.querySelector(".scroll-top").classList.remove("scroll-top--visible");
			}
		};

		const scrollTo = (element, distance) => {
			window.scroll({
				behavior: "smooth",
				left: 0,
				top: element.offsetTop - distance
			});
		};

		const scrollHandler = () => {

			const pathname = window.location.pathname;
			const offerRegEx = /\b(oferta)\b/g;
			const blogRegEx = /\b(blog)\b/g;

			if (pathname.match(offerRegEx) || pathname.match(blogRegEx)) {} else {
				const mainNav = document.querySelector(".menu__wrapper--dark").getBoundingClientRect().top;
				const navLinks = document.querySelectorAll(".menu__link");

				navLinks.forEach((link) => {
					link.addEventListener("click", (e) => {
						if (e.currentTarget.hash && window.location.pathname === "/" || e.currentTarget.hash && window.location.pathname === "/horizon/") {
							e.preventDefault();
							scrollTo(document.querySelector(`${e.currentTarget.hash}`), mainNav);
							menu.classList.toggle("menu--is-open");
							menuBtn.classList.toggle("menu__btn--active");
						}
					});
				});
			}
		};

		scrollHandler();

		const scrollToTop = () => {
			window.scroll({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}

		document.querySelector(".scroll-top").addEventListener("click", scrollToTop);

		/* Polityka prywatności */

		const policyBtn = document.querySelector(".menu__policy");
		const closeRegulations = document.querySelector(".popup__btn-policy--close");
		const policy = document.querySelector(".popup--policy");

		policyBtn.addEventListener("click", (e) => {
			e.preventDefault();
			disableBodyScroll(policy);
			policy.classList.add("popup--visible");
		});

		closeRegulations.addEventListener("click", (e) => {
			e.preventDefault();
			enableBodyScroll(policy);
			policy.classList.remove("popup--visible");
		});

		/* Cookies */

		const overlay = document.querySelector(".overlay");
		const cookies = document.querySelector(".popup--cookies");
		const cookiesBtns = document.querySelectorAll(".popup__btn--cookies");

		if (!localStorage.cookiesAccepted) {
			document.body.classList.add("body--no-scroll");
			overlay.classList.add("overlay--visible");
			cookies.classList.add("popup--visible");
		}

		cookiesBtns.forEach((btn, index) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				if (index === 0) {
					window.location.href = "https://google.pl/";
				} else if (index === 1) {
					localStorage.cookiesAccepted = true;
					document.body.classList.remove("body--no-scroll");
					overlay.classList.remove("overlay--visible");
					cookies.classList.remove("popup--visible");
				}
			});
		});

		/* iOS */

		const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

		if (isIOS) {
			const popups = document.querySelectorAll(".popup");
			popups.forEach((popup) => {
				if (window.innerWidth < 1100) {
					popup.setAttribute("style", "-webkit-overflow-scrolling: touch");
					popup.style.overflow = "scroll";
					popup.style.height = "50vh";
					popup.style.maxHeight = "unset";
					popup.style.padding = "2rem";

					popup.children[1].setAttribute("style", "-webkit-overflow-scrolling: touch");
					popup.children[1].style.overflow = "scroll";
					popup.children[1].style.maxHeight = "unset";
					popup.children[1].style.height = "40vh";
					popup.children[1].style.position = "absolute";
					popup.children[1].style.left = "0";
					popup.children[1].style.padding = "2rem";

					popup.children[2].style.position = "absolute";
					popup.children[2].style.bottom = "0";
					popup.children[2].style.left = "0";
					popup.children[2].style.width = "100%";
					popup.children[2].style.margin = "0";

				}
			});
		}
	},
	finalize() {

	},
};